import { ActionType } from "../../classes/calendar-actions";
import { ICalendarSettings } from "../../classes/calendar";

export function updateCalendarSettings(newSettings: ICalendarSettings) {
    return {
        type: ActionType.UpdateSettings,
        value: newSettings
    }
}

/**
 * Dispatch this to set the application state to MOBILE mode.
 */
export function setToMobile() {
    return {
        type: ActionType.SetToMobile
    }
}

/**
 * Dispatch this to set the application state to DESKTOP mode.
 */
export function setToDesktop() {
    return {
        type: ActionType.SetToDesktop
    }
}

export function setToGrid() {
    return {
        type: ActionType.SetToGrid
    }
}

export function setToList() {
    return {
        type: ActionType.SetToList
    }
}